export const MuiPickersToolbarText = {
  toolbarTxt: {
    fontSize: '2rem'
  }
}
